import { User } from 'oidc-client-ts';
import { Role } from '../graphql/schema';

const hasRole = (user: User | undefined | null, roles: Role[]) => {
  if (!user) return false;
  const usersRoles = user.profile['cognito:groups'] as string[] | undefined;
  for (const role of roles) {
    if (usersRoles?.includes(role)) return true;
  }
  return false;
};

export default hasRole;
